/* eslint-disable @typescript-eslint/no-explicit-any */
export function setConfig(config: any): BaseTockAction {
  return {
    type: 'SET_CONFIG',
    payload: config,
  };
}

export function setShouldResetBeforeUnload(shouldReset: any): BaseTockAction {
  return {
    type: 'SET_SHOULD_RESET_BEFORE_UNLOAD',
    payload: shouldReset,
  };
}

export function setRecentlyResynced(aboutToResync: boolean): BaseTockAction {
  return {
    type: 'SET_RECENTLY_RESYNCED',
    payload: aboutToResync,
  };
}
